import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setOverlayPartnerVisible } from './actions';
import OverlayGeneric from '../../components/Overlay/OverlayGeneric';
import PartnerLogo from '../../components/Donation/PartnerLogo';
import PartnerDescription from '../../components/Overlay/CustomDescription';

import { getImageUrl } from '../../utils/imageLoading';

const LogoComponent = props => (
    <a
        href="https://votesmart.org/"
        alt="Vote Smart"
        target="_blank"
        rel="noopener noreferrer"
    >
        <PartnerLogo {...props} />
    </a>
);

const OverlayVoteSmart = props => {
    return (
        <OverlayGeneric
            logoComponent={LogoComponent}
            aboutUsComponent={PartnerDescription}
            aboutUsContent={{
                description: props.partnerDescription,
                logoUrl: props.partnerLogoUrl
            }}
            logoIsSmall={props.logoIsSmall}
            isVisible={props.isVisible}
            isMobileResolution={props.isMobileResolution}
            setOverlayVisible={props.setOverlayPartnerVisible}
            transitionType={props.transitionType}
            title={props.title}
            logo={props.logo}
            name={props.name}
            description={props.description}
            isActionChoiceOverlay={false}
            isVoteSmartOverlay={true}
            isPartnerOrPublisherOverlay={true}
        />
    );
};

OverlayVoteSmart.propTypes = {
    description: PropTypes.string,
    isMobileResolution: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    logo: PropTypes.string,
    logoIsSmall: PropTypes.bool,
    name: PropTypes.string,
    partnerDescription: PropTypes.string.isRequired,
    partnerLogoUrl: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    title: PropTypes.string,
    transitionType: PropTypes.string.isRequired
};

export default connect(
    state => ({
        isVisible: state.widget.isOverlayVoteSmartVisible,
        isPartnerOverlayTransitionRegular: true,
        isMobileResolution: state.widget.isMobileResolution,
        partnerDescription: `<a href="https://votesmart.org/about" target="_blank" rel="noopener noreferrer">Vote Smart</a>'s mission is to provide free, factual, unbiased information on candidates and elected officials to ALL Americans.<br/><br/>Vote Smart is an idea begun by Presidents Carter and Ford, Senators McCain, Goldwater and McGovern and 35 other national leaders. <a href="https://votesmart.org/donate" target="_blank" rel="noopener noreferrer">Vote Smart</a> tracks every official and candidate running for public office at the state and national level and covers 6 basic areas of public interest: voting records, issue positions, public comments, special interest ratings, biographies and campaign contributors, creating a vast voter's self-defense system maintained by our dedicated group of staff, interns and volunteers.`,
        partnerLogoUrl: getImageUrl('votesmart.png', 'DEFAULT_IMAGES_URL'),
        title: ''
    }),
    { setOverlayPartnerVisible }
)(OverlayVoteSmart);
